//  __         __     __   __     ______     __  __     ______        __   __     ______     ______  
// /\ \       /\ \   /\ "-.\ \   /\  ___\   /\ \/ /    /\  ___\      /\ "-.\ \   /\  ___\   /\__  _\ 
// \ \ \____  \ \ \  \ \ \-.  \  \ \ \__ \  \ \  _"-.  \ \  __\      \ \ \-.  \  \ \  __\   \/\ \// 
//  \ \_____\  \ \_\  \ \_\"\_\  \ \_____\  \ \_\ \_\  \ \_____\     \ \_\"\_\  \ \_____\    \ \_\ 
//   \/_____/   \/_/   \/_/ \/_/   \/_____/   \/_/\/_/   \/_____/      \/_/ \/_/   \/_____/     \/_/ 
//                                                                                                  
// 所有权利归Lingke Network (china)所有 | dream_pep拥有其艺术改变权力
// 未经允许的情况下删除此版权头可能会受到民事指控
// 请勿在未经Lingke Network (china)允许的范围内修改代码并分发

import { useState, type ComponentType } from "react";
import { Info, AlertTriangle, CheckCircle2, X, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

type BannerVariant = "info" | "warning" | "success" | "destructive";

interface BannerProps {
  message?: string;
  variant?: BannerVariant;
  dismissible?: boolean;
  className?: string;
}

const variantStyles: Record<BannerVariant, string> = {
  info: "bg-blue-50 text-blue-800 border-blue-200",
  warning: "bg-amber-50 text-amber-900 border-amber-200",
  success: "bg-green-50 text-green-800 border-green-200",
  destructive: "bg-red-50 text-red-700 border-red-200",
};

const variantIcon: Record<BannerVariant, ComponentType<any>> = {
  info: Info,
  warning: AlertTriangle,
  success: CheckCircle2,
  destructive: XCircle,
};

export function Banner({
  message = "One Account 处于测试状态",
  variant = "warning",
  dismissible = false,
  className,
}: BannerProps) {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;

  const Icon = variantIcon[variant];

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "relative flex items-center justify-center gap-3 border px-4 py-2",
        variantStyles[variant],
        className,
      )}
    >
      <div className="flex items-center gap-2 justify-center">
        <Icon className="h-5 w-5" aria-hidden="true" />
        <p className="text-sm font-medium text-center">{message}</p>
      </div>
      {dismissible && (
        <button
          type="button"
          onClick={() => setHidden(true)}
          aria-label="关闭横幅"
          className="absolute right-2 inline-flex items-center rounded p-1 hover:bg-black/5"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export default Banner;
